import s from "./index269.mjs";
class u {
  constructor(e) {
    this.maxWorkers = e, this.workers = [], this.queue = [], this.timeout = null;
  }
  /**
   * Clear dangling workers every 5 seconds
   */
  clearDanglingWorkers() {
    this.timeout || (this.timeout = setInterval(() => {
      if (this.workers.length === 0) {
        this.timeout && (clearTimeout(this.timeout), this.timeout = null);
        return;
      }
      this.workers.filter(
        (r) => r.startedAt && Date.now() - r.startedAt.getTime() > 5e3
      ).forEach((r) => {
        this.terminateWorker(r.id).catch();
      });
    }, 5e3));
  }
  /**
   * Add a worker to the pool
   * @param worker
   */
  addWorker(e) {
    const r = {
      id: s(),
      ...e
    };
    return this.queue.push(r), this.processQueue(), r;
  }
  /**
   * Process the queue
   */
  processQueue() {
    if (this.queue.length === 0 || this.workers.length >= this.maxWorkers) return;
    this.clearDanglingWorkers();
    const e = this.queue.pop();
    if (!e) return;
    const r = e.createWorker(), t = {
      id: e.id,
      worker: r,
      startedAt: /* @__PURE__ */ new Date()
    };
    this.workers.push(t), r.onmessage = async (i) => {
      e.onMessage(i), await this.terminateWorker(t.id), e.onFinish && e.onFinish();
    }, r.onerror = async (i) => {
      e.onError && e.onError(i), await this.terminateWorker(t.id), e.onFinish && e.onFinish();
    }, r.onmessageerror = async (i) => {
      e.onMessageError && e.onMessageError(i), await this.terminateWorker(t.id), e.onFinish && e.onFinish();
    }, e.onWorkerInitialized(t);
  }
  /**
   * Terminate a worker
   * @param id
   */
  async terminateWorker(e) {
    if (!e) return;
    const r = this.workers.findIndex((t) => t.id === e);
    r !== -1 && (await this.workers[r].worker.terminate(), this.workers.splice(r, 1), this.processQueue());
  }
  /**
   * Remove from queue
   * @param id
   */
  removeFromQueue(e) {
    const r = this.queue.findIndex((t) => t.id === e);
    r !== -1 && this.queue.splice(r, 1);
  }
}
export {
  u as Pool
};
